"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _types = require("./types");
Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _types[key];
    }
  });
});
var _sendCodeFailed = require("./sendCodeFailed");
Object.keys(_sendCodeFailed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendCodeFailed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendCodeFailed[key];
    }
  });
});
var _sendCodeSucceed = require("./sendCodeSucceed");
Object.keys(_sendCodeSucceed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendCodeSucceed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendCodeSucceed[key];
    }
  });
});
var _sendCodeLoading = require("./sendCodeLoading");
Object.keys(_sendCodeLoading).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendCodeLoading[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendCodeLoading[key];
    }
  });
});
var _sendCodeSms = require("./sendCodeSms");
Object.keys(_sendCodeSms).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendCodeSms[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendCodeSms[key];
    }
  });
});
var _sendCodeMultichannel = require("./sendCodeMultichannel");
Object.keys(_sendCodeMultichannel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendCodeMultichannel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _sendCodeMultichannel[key];
    }
  });
});
var _changePhone = require("./changePhone");
Object.keys(_changePhone).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changePhone[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changePhone[key];
    }
  });
});
var _changeAutosubmit = require("./changeAutosubmit");
Object.keys(_changeAutosubmit).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _changeAutosubmit[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _changeAutosubmit[key];
    }
  });
});